import React, { useEffect, useState } from 'react';
import axios from 'axios';

interface SteamProfileProps {
    apiKey: string;
    steamId: string;
}

interface Player {
    avatarfull: string;
}

function Community({ apiKey, steamId }: SteamProfileProps) {
    const [avatarUrl, setAvatarUrl] = useState<string>('');

    useEffect(() => {
        async function fetchAvatar() {
            try {
                const response = await axios.get(`https://api.steampowered.com/ISteamUser/GetPlayerSummaries/v0002/`, {
                    params: {
                        key: apiKey,
                        steamids: steamId,
                    },
                });

                const player: Player = response.data.response.players[0];
                setAvatarUrl(player.avatarfull);
            } catch (error) {
                console.error('Error loading Steam profile:', error);
            }
        }

        fetchAvatar();
    }, [apiKey, steamId]);

    console.log(avatarUrl);
    return <img src={avatarUrl} alt="Steam Avatar" />;
}

export default Community;